(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-ord"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback(){
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0; this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback(){ this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver(){
      let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
      observer.observe(this.header);
    }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal){ requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(()=>{ this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top){
        this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
    closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
    closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-slider"] && !Shopify.designMode) return;
  try {
    
  if (!window.hotspotObserverInitialized) {
    window.hotspotObserverInitialized = true;

    // ==============================
    // ホットスポット位置更新処理
    // ==============================
    function updateHotspots() {
      const images = document.querySelectorAll('.images-container img');
      const hotspots = document.querySelectorAll('.hotspot');
      const imageHeights = Array.from(images).map((img) => img.clientHeight);

      const isSpLayout = window.matchMedia('(max-width: 839px)').matches;
      hotspots.forEach((hotspot) => {
        /* SP では display を触らない（inline の block 指定が display:none を潰し一瞬チラつくのを防ぐ） */
        if (!isSpLayout) {
          hotspot.style.display = 'block';
        } else {
          hotspot.style.removeProperty('display');
        }
        const slideIndex = parseInt(hotspot.dataset.slideIndex, 10);
        const topPercent = parseFloat(hotspot.dataset.topPercent);
        const leftPercent = parseFloat(hotspot.dataset.leftPercent);

        if (isNaN(slideIndex) || isNaN(topPercent) || isNaN(leftPercent) || !imageHeights[slideIndex]) return;

        const imageOffsetTops = [];
        let totalHeight = 0;
        for (let h of imageHeights) {
          imageOffsetTops.push(totalHeight);
          totalHeight += h;
        }
        const topPx = imageOffsetTops[slideIndex] + (topPercent / 100) * imageHeights[slideIndex];

        hotspot.style.top = `${topPx}px`;
        hotspot.style.left = `${leftPercent}%`;
      });
    }

    function initializeHotspotObserver() {
      updateHotspots();
      window.addEventListener('resize', updateHotspots);
    }

    window.addEventListener('load', initializeHotspotObserver);
    document.addEventListener('shopify:section:load', initializeHotspotObserver);
    document.addEventListener('shopify:section:select', initializeHotspotObserver);

    // ============================
    // 端末判定
    // ============================
    const isTablet = () => window.matchMedia('(max-width: 839px) and (min-width: 541px)').matches;
    const isMobile = () => window.matchMedia('(max-width: 540px)').matches;

    // ============================
    // 2段階タップ動作 & ツールチップ遷移
    // ============================
    function initializeHotspotToggle() {
      const wrapper = document.querySelector('.hotspot-wrapper');
      if (!wrapper) return;
      const hotspots = wrapper.querySelectorAll('.hotspot');

      // 画像タップでホットスポット表示
      wrapper.addEventListener('click', (event) => {
        if (!isTablet() && !isMobile()) return;
        if (event.target.closest('.hotspot-tooltip')) return;
        if (event.target.closest('.hotspot')) return;

        if (wrapper.classList.contains('show-hotspots')) {
          wrapper.classList.remove('show-hotspots');
          hotspots.forEach((hs) => hs.classList.remove('active'));
        } else {
          wrapper.classList.add('show-hotspots');
        }
      });

      // 各ホットスポットの処理
      hotspots.forEach((hotspot) => {
        const link = hotspot.getAttribute('href');
        const tooltip = hotspot.querySelector('.hotspot-tooltip');

        // ホットスポットタップでツールチップ表示
        hotspot.addEventListener('click', (event) => {
          if (!isTablet() && !isMobile()) return;
          event.preventDefault();

          // ホットスポットが非表示なら画像タップ扱い
          if (!wrapper.classList.contains('show-hotspots')) {
            wrapper.classList.add('show-hotspots');
            return;
          }

          const isActive = hotspot.classList.contains('active');
          hotspots.forEach((hs) => hs.classList.remove('active'));
          if (!isActive) hotspot.classList.add('active');
        });

        // ツールチップタップで商品ページ遷移
        if (tooltip) {
          tooltip.addEventListener('click', (event) => {
            event.stopPropagation();
            window.location.href = link;
          });
        }
      });

      // 外側クリックで全て閉じる
      document.addEventListener('click', (event) => {
        if (!isTablet() && !isMobile()) return;
        if (event.target.closest('.hotspot-wrapper')) return;
        wrapper.classList.remove('show-hotspots');
        hotspots.forEach((hs) => hs.classList.remove('active'));
      });
    }

    document.addEventListener('DOMContentLoaded', initializeHotspotToggle);
    document.addEventListener('shopify:section:load', initializeHotspotToggle);
  }

  } catch(e) { console.error(e); }
})();
})();
